import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from 'atoms/buttons/Button';
import { HomeLink } from 'atoms/navigation/HomeLink';
import ResponsiveSearchBar from 'components/search/ResponsiveSearchBar';
import { useConnectionContext } from 'contexts/connection';
import { glossary } from 'lib/glossary';
import AppBarProvider from 'routing/MultiSportAppBar/context/Provider';
import { mobileAndAbove, tabletAndAbove } from 'style/mediaQuery';

const Wrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  gap: var(--unit);
  padding: var(--unit) var(--double-unit);
  @media ${tabletAndAbove} {
    padding: var(--unit) var(--quadruple-unit);
  }
`;

const Spacer = styled.div`
  @media ${tabletAndAbove} {
    background: var(--c-static-neutral-600);
    margin: 0 var(--unit);
    width: 1px;
    height: 30px;
  }
`;

const HideOnMobile = styled.div`
  display: none;
  @media ${mobileAndAbove} {
    display: block;
  }
`;

export const LoggedOutAppHeader = ({ children }: { children: ReactNode }) => {
  const { signIn, signUp } = useConnectionContext();

  return (
    <Wrapper>
      <HomeLink withStarball />
      <Spacer />
      <HideOnMobile>{children}</HideOnMobile>
      <div style={{ flex: 1 }} />
      <AppBarProvider>
        <ResponsiveSearchBar />
      </AppBarProvider>
      <Button size="medium" color="tertiary" onClick={signUp}>
        <FormattedMessage {...glossary.signup} />
      </Button>
      <Button size="medium" color="primary" onClick={signIn}>
        <FormattedMessage {...glossary.signin} />
      </Button>
    </Wrapper>
  );
};
